import { render, staticRenderFns } from "./QPBuilder.vue?vue&type=template&id=8818d64c"
import script from "./QPBuilder.vue?vue&type=script&lang=js"
export * from "./QPBuilder.vue?vue&type=script&lang=js"
import style0 from "./QPBuilder.vue?vue&type=style&index=0&id=8818d64c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports